import { BuildingQuarter, IOfferCard } from '../../../types';

export function getBuildingDeadline(offerCard: IOfferCard): string | undefined {
  const { deadline, buildYear } = offerCard.building || {};

  if (deadline) {
    if (deadline.isComplete) {
      return 'дом сдан';
    }

    if (deadline.quarter) {
      let text = `сдача ГК: ${BuildingQuarter[deadline.quarter]} кв.`;

      if (deadline.year) {
        text += ` ${deadline.year} года`;
      } else if (buildYear) {
        text += ` ${buildYear} года`;
      }

      return text;
    }
  }

  return undefined;
}
